import {flow, get, split} from '@yandex-delivery/utils'
import {toDate} from 'src/shared/utils'

const toISOStringDate = (dateLike: Date | string) =>
  toDate(dateLike).toISOString()

export const convertToStandardDate: (date: string) => string = flow(
  toISOStringDate,
  split('T'),
  get('0'),
)
